<template>
  <div
    id="terms-and-conditions-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-scrollable tos-width tos-font-size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-xs-12">
              <h2 v-if="!auth || has_terms || terms_accepted">Terms of Service</h2>
              <h2 v-else>Terms of Service Updated</h2>
              <button
                v-if="!auth || has_terms || terms_accepted"
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <h4>Vehicle Shipping Terms and Conditions</h4>
        </div>
        <div class="tos-modal-body" id="terms" name="licenseAgreement">
<!--          TODO: Update this so the formatting of the markdown file is still respected-->
          <p>{{fileContent}}</p>
<!--          <VueShowdown :markdown="fileContent" flavor="github" :options="{ emoji: false }"></VueShowdown>-->
        </div>
        <div class="modal-footer" id="footer">
          <button
            v-if="!has_terms && !terms_accepted"
            type="button"
            class="btn btn-primary btn-rounded"
            v-on:click="agree"
            :disabled="(!button_enabled)"
            id="terms_button"
          >Agree and Continue</button>
          <button
            v-else
            type="button"
            class="btn btn-secondary btn-rounded"
            data-dismiss="modal"
            id="terms_button"
          >Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
    axios
  },
  props: {
    auth: {
      type: Boolean,
      default: false
    },
    has_terms: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      button_enabled: false,
      fileContent: "rendering..",
      fileToRender: "https://vinlocity.s3.amazonaws.com/tos/tos.md",
      rawContent: null,
      terms_version: null,
      terms_accepted: false
    };
  },
  methods: {
    checkScrollHeight() {
      let agreementTextElement = document.getElementsByName(
        "licenseAgreement"
      )[0];

      if (
        agreementTextElement.scrollTop + agreementTextElement.offsetHeight >=
        agreementTextElement.scrollHeight - 5
      ) {
        this.button_enabled = true;
      }
    },
    getContent() {
      this.fileContent = "rendering..";

      axios.get(this.fileToRender).then(
        function(response) {
          this.fileContent = response.data;
          this.terms_version = response.headers["last-modified"];
        }.bind(this)
      );
    },
    agree() {
      this.terms_accepted = true;

      if (document.getElementsByName("tos")[0]) {
        document.getElementsByName("tos")[0].disabled = false;
        document.getElementsByName("register")[0].disabled = false;
      }

      if (this.auth) {
        axios
          .post("/tos", {
            terms_version: this.terms_version,
            terms_accepted: this.terms_accepted
          })
          .then(
            function(response) {
              $("#terms-and-conditions-modal").modal("hide");
            }.bind(this)
          );
      }
    }
  },
  mounted() {
    this.getContent();
    document
      .getElementsByName("licenseAgreement")[0]
      .addEventListener("scroll", this.checkScrollHeight, false);
  }
};
</script>

<style>
.modal-dialog-scrollable {
  overflow-y: initial;
}
.tos-modal-body {
  height: 450px;
  overflow-y: auto;
  padding-left: 8px;
  padding-right: 8px;
}
.tos-width {
  width: 65%;
}
.tos-font-size {
  font-size: 13px;
}
</style>